var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{ref:"select",staticClass:"style-chooser-schedule",class:{
        search: true,
        'nav-search': true,
        appointments: true,
        ci: _vm.isCI
    },attrs:{"placeholder":_vm.placeholder,"noDrop":_vm.isDisableDrop,"options":_vm.options,"disabled":_vm.isDisabled},on:{"search":_vm.fetchAppointments,"input":_vm.submit},scopedSlots:_vm._u([{key:"option",fn:function(ref){
    var label = ref.label;
return [_c('b',[_vm._v(_vm._s(label))])]}}]),model:{value:(_vm.selectedAppointment),callback:function ($$v) {_vm.selectedAppointment=$$v},expression:"selectedAppointment"}})}
var staticRenderFns = []

export { render, staticRenderFns }